import React, { useEffect, useState } from 'react';
import styles from './DpProduct.module.scss';
import DpTableMobileSection from './DpTableMobileSection/DpTableMobileSection';
import DpTableDeviceSection from './DpTableDeviceSection/DpTableDeviceSection';
import DpTableFlexSection from './DpTableFlexSection/DpTableFlexSection';
import RichText from '../richtext';
import {
  checkLinkWithLang,
  countZero,
  getElementMaximumHeight,
  replacePlaceholder
} from '../../utils/utils';
import {
  AssetPathPropConfig,
  LineTableBasicPropConfig
} from '../../services/LineTableBasicPropConfig';
import { dpTableCreateCart, getDeviceNotes, setDeviceSessionObject } from './DpTableUtils';
import Cookies from 'js-cookie';
import { createPortal } from 'react-dom';
import Dotloader from '../Dotloader/Dotloader';
import CheckoutRedirectionPopup from './checkoutRedirectionPopup/checkoutRedirectionPopup';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import { CONTRACT, HARDWARE, NOT_AVAILABLE, ONE_ECOMMERCE_HARDWARE_SUMMARY } from '../../utils/constants';
import DpDetailsModal from './DpDetailsModal/DpDetailsModal';

const DpProduct = ({
  productData, //product's SB content
  mainContent, //whole content
  tabIndex,
  indexKey, //product index
  cardsLength, //total number of products
  offerDataList, //offerAPI response
  activeTab, //active tab index
  deviceModelsList, //device list to show in dropdown
  deviceDetailsList, //device hardware details memory, color and price
  fetchDeviceDetails,
  metadata,
  isProdEnv
}: any) => {
  const endPoint = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
  const basicConfigUrl = AssetPathPropConfig?.getInstance()?.getBasicConfigUrl();
  const [deviceDetails, setDeviceDetails] = useState<any>(); // to store the selected device details, used for callback
  const [showLoader, setShowLoader] = useState(false);
  const [totalDiscountedPrice, setTotalDiscountedPrice] = useState(0);
  const [totalBasePrice, setTotalBasePrice] = useState(0);
  const [contractDuration, setContractDuration] = useState(0);
  const [isOpen, setIsOpen] = useState(false); //state to open the redirection popup
  const [isOutStock, setIsOutStock] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const portalPosition: any =
    typeof window !== undefined && document.getElementById('devicePlan-linetable');
  let AuthData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
  AuthData = AuthData && JSON.parse(AuthData);

  //on click of add to cart button
  const onClickHandler = () => {
    showDetailsModal && setShowDetailsModal(false);
    if (AuthData?.siteId) {
      //creating with price values
      const priceValues = {
        totalDiscountedPrice: totalDiscountedPrice,
        totalBasePrice: totalBasePrice
      };
      //Setting the hardware session obj and redirecting to handys-v2
      setDeviceSessionObject(
        mainContent,
        productData,
        offerDataList,
        deviceDetails,
        priceValues,
        checkLinkWithLang(mainContent?.devicePageUrl?.url)
      );
    } else {
      setIsOpen(true);
    }
  };

  const createCart = () => {
    setIsOpen(false);
    if (productData && deviceDetails) {
      const insuranceValue =
        deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.insurance
          ?.value ?? 0;
      const upFrontValue =
        deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.upFrontPayment
          ?.value ?? '';
      const sessionObj: any = {
        hardwareVariant: {
          id: deviceDetails?.selectedVarientDetails?.id,
          note: getDeviceNotes(deviceDetails, upFrontValue),
          hardwarePrices: deviceDetails?.selectedVarientDetails?.hardwarePrices,
          selectedContractType: CONTRACT,
          deviceRedirectUrl: '',
          buyBackPrice: [],
          itemType: HARDWARE,
          insuranceName: insuranceValue ? mainContent?.insuranceId ?? '' : '', //flex name to be replaced with the actul name from res
          insurancePrice: insuranceValue ? insuranceValue : ''
        },
        checkSubscriptions: {
          simSelectedType: '',
          enableV2Layout: true,
          enableNoSubscriptionFlow: true,
          dpSubsidyRatePlanPromoId: '',
          flowType: 'dpTable',
          enableRecommendedAccessory: deviceDetails?.selectedVarientDetails?.classification?.recommendAccessory ?? false
        },
      };
      sessionObj && sessionStorage.setItem(ONE_ECOMMERCE_HARDWARE_SUMMARY, JSON.stringify(sessionObj));

      // to check multi item accessory from storyblock and if recommended accessory flag is tru from hardware api
      const isMiaCompatible = deviceDetails?.selectedVarientDetails?.classification?.recommendAccessory ?? false;

      //create cart function
      dpTableCreateCart(
        setShowLoader,
        mainContent,
        productData,
        deviceDetails,
        endPoint,
        checkLinkWithLang(isMiaCompatible ? mainContent?.multiItemPageRedirectionUrl?.cached_url : mainContent?.summaryPageURL?.cached_url)
      );
    }
  };

  const onLoginSuccess = () => {
    setIsOpen(false);
    const priceValues = {
      totalDiscountedPrice: totalDiscountedPrice,
      totalBasePrice: totalBasePrice
    };
    if (offerDataList && deviceDetails) {
      //Setting the hardware session obj and redirecting to handys-v2
      setDeviceSessionObject(
        mainContent,
        productData,
        offerDataList,
        deviceDetails,
        priceValues,
        checkLinkWithLang(mainContent?.devicePageUrl?.url)
      );
    }
  };

  // useEffect to set the height of the elements
  useEffect(() => {
    setTimeout(() => {
      findHeight();
    }, 100);
    window?.addEventListener('load', findHeight);
    window?.addEventListener('resize', findHeight);
    return () => {
      window.removeEventListener('resize', findHeight);
      window.removeEventListener('load', findHeight);
    };
  }, [productData]);

  const findHeight = () => {
    getElementMaximumHeight(`priceBadgeSection${tabIndex}`, cardsLength);
    getElementMaximumHeight(`priceDescSection${tabIndex}`, cardsLength);
    getElementMaximumHeight(`totalPriceSection${tabIndex}`, cardsLength);
    getElementMaximumHeight(`durationSection${tabIndex}`, cardsLength);
  };

  const priceSection = () => (
    <div className={styles.totalPriceContainer} id={`totalPriceSection${tabIndex}${indexKey}`}>
      <div className={styles.totalDiscountedPrice}>
        {/* total price after discount */}
        {countZero(totalDiscountedPrice)}
        <span className={styles.month}>{mainContent?.contractLabel}</span>
      </div>
      {/* total original price  */}
      <div className={styles.totalBasePrice}>{countZero(totalBasePrice)}</div>
    </div>
  );

  const addToCartButton = () => (
    <button
      className={`${styles.addToCartButton} ${
        productData?.ribbonBadge ? styles.productPrimaryButton : ''
      } ${isOutStock && styles?.disableButton}`}
      onClick={onClickHandler}
      disabled={isOutStock}
    >
      {productData?.orderBtnLbl}
    </button>
  );

  useEffect(() => {
    //to calculate the total price of all the items
    if (
      (deviceDetails && deviceDetails?.selectedVarientDetails?.id) ||
      (offerDataList && offerDataList?.[productData?.mobProductId]?.id)
    ) {
      //mobile prices
      const mobDiscountedPrice = offerDataList?.[productData?.mobProductId]?.derivedPrice?.[0]
        ?.value
        ? offerDataList?.[productData?.mobProductId]?.derivedPrice?.[0]?.value
        : 0;
      const mobBasePrice = offerDataList?.[productData?.mobProductId]?.prices?.[0]?.value
        ? offerDataList?.[productData?.mobProductId]?.prices?.[0]?.value
        : 0;
      const mobileContractDuration = parseInt(
        offerDataList?.[productData?.mobProductId]?.contractDuration ?? 0
      );

      //device prices
      const deviceDiscountedPrice =
        deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments
          ?.monthlyInstallment?.value ?? 0;
      const deviceBasePrice =
        deviceDetails?.selectedVarientDetails?.hardwarePrices?.installments?.monthlyInstallment
          ?.value ?? 0;
      const insurancePrice =
        deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.insurance
          ?.value ?? 0;
      const deviceContractDuration =
        deviceDetails?.selectedVarientDetails?.hardwarePrices?.smartUpgradeInstallments?.duration ??
        deviceDetails?.selectedVarientDetails?.hardwarePrices?.installments?.duration ??
        0;

      setTotalDiscountedPrice(
        parseFloat(mobDiscountedPrice) +
          parseFloat(deviceDiscountedPrice) +
          parseFloat(insurancePrice)
      );
      setTotalBasePrice(
        parseFloat(mobBasePrice) + parseFloat(deviceBasePrice) + parseFloat(insurancePrice)
      );
      setContractDuration(Math.max(mobileContractDuration, deviceContractDuration));
      if (
        deviceDetails?.selectedVarientDetails?.availabilityStatus === NOT_AVAILABLE ||
        mobBasePrice === 0 ||
        deviceBasePrice === 0
      ) {
        setIsOutStock(true);
      } else {
        setIsOutStock(false);
      }
    }
  }, [deviceDetails, offerDataList, deviceDetails?.selectedColor, deviceDetails?.selectedStorage]);

  return (
    <>
      <div
        className={`${styles.productContainer} ${
          productData?.ribbonBadge ? styles.productRibbon : ''
        }`}
      >
        {/* badge section of the product */}
        {productData?.ribbonBadge && (
          <div className={styles.productRibbonBadge}>{productData?.ribbonBadge}</div>
        )}
        <DpTableMobileSection
          productData={productData}
          mainContent={mainContent}
          offerDataList={offerDataList}
          tabIndex={tabIndex}
          indexKey={indexKey}
          cardsLength={cardsLength}
        />
        <DpTableDeviceSection
          productData={productData}
          mainContent={mainContent}
          tabIndex={tabIndex}
          indexKey={indexKey}
          cardsLength={cardsLength}
          activeTab={activeTab}
          deviceModelsList={deviceModelsList}
          deviceDetailsList={deviceDetailsList}
          setDeviceDetails={setDeviceDetails}
          fetchDeviceDetails={fetchDeviceDetails}
        />
        <DpTableFlexSection
          productData={productData}
          mainContent={mainContent}
          selectedDeviceDetails={deviceDetails}
          tabIndex={tabIndex}
          indexKey={indexKey}
          activeTab={activeTab}
          cardsLength={cardsLength}
        />
        {/* total price section */}
        <div className={styles.totalPriceSection}>
          {/* great offer badge */}
          {productData?.badge?.length > 0 && (
            <div className={styles.priceBadge} id={`priceBadgeSection${tabIndex}${indexKey}`}>
              <img src={productData?.badge?.[0]?.icon?.filename} alt='' width={16} height={16} />
              <RichText content={productData?.badge?.[0]?.text} />
            </div>
          )}
          {/* price description */}
          <div className={styles.priceDescription} id={`priceDescSection${tabIndex}${indexKey}`}>
            {productData?.priceDescriptionTxt}
          </div>
          {totalDiscountedPrice > 0 || totalBasePrice > 0 ? (
            <>{priceSection()}</>
          ) : (
            <div className={styles.skeletonStyles}>
              <SkeletonLoader count={1} />
            </div>
          )}
          {(totalDiscountedPrice > 0 || totalBasePrice > 0) && productData?.orderBtnLbl && (
            <>{addToCartButton()}</>
          )}
          <div className={styles.totalPriceDuration}>
            {replacePlaceholder(productData?.contractDuration, [contractDuration])}
          </div>
          {productData?.productDetailsLbl && (
            <div
              className={styles.productDetails}
              onClick={() => setShowDetailsModal(!showDetailsModal)}
            >
              {productData?.productDetailsLbl}
            </div>
          )}
        </div>
        {/* redirection pop up */}
        {isOpen &&
          portalPosition &&
          createPortal(
            <CheckoutRedirectionPopup
              content={mainContent?.customerSection?.[0]}
              metadata={metadata}
              togglePopup={() => setIsOpen(!isOpen)}
              isOpen={isOpen}
              validation={createCart}
              onLoginSuccessRedirection={onLoginSuccess}
              wafIdentifier={basicConfigUrl}
              isProdEnv={isProdEnv}
            />,
            portalPosition
          )}
        {showLoader &&
          portalPosition &&
          createPortal(<Dotloader keyParams='loading' />, portalPosition)}
        {showDetailsModal &&
          portalPosition &&
          createPortal(
            <DpDetailsModal
              content={productData?.productDetails}
              showProductDetail={showDetailsModal}
              setShowProductDetail={setShowDetailsModal}
              priceSection={priceSection}
              addToCartButton={addToCartButton}
              priceDuration={replacePlaceholder(productData?.contractDuration, [contractDuration])}
            />,
            portalPosition
          )}
      </div>
    </>
  );
};

export default DpProduct;
